import React from "react";
import { useWalletPermission } from "../hooks/useWalletPermission";
import { CheckLocation } from "./CheckLocation";
import { CheckVerified } from "@/features/auth/components/CheckVerified";
import { CheckNeedsReopen } from "./CheckNeedsReopen";
import { CheckBlocked } from "./CheckBlocked";
import { CheckCooldown } from "./CheckCooldown";

type CheckPermissionsProps = {
  children: React.ReactNode;
  type: "deposit" | "withdraw";
};

const CheckPermissions = ({ type, children }: CheckPermissionsProps) => {
  const { permission = "" } = useWalletPermission(type);

  return (
    <CheckLocation
      permission={permission}
      title={
        type === "deposit"
          ? "Deposits coming to your region soon"
          : "Withdrawals coming to your region soon"
      }
    >
      <CheckVerified permission={permission}>
        <CheckNeedsReopen permission={permission}>
          <CheckBlocked permission={permission} type={type}>
            <CheckCooldown permission={permission} type={type}>
              {children}
            </CheckCooldown>
          </CheckBlocked>
        </CheckNeedsReopen>
      </CheckVerified>
    </CheckLocation>
  );
};

export { CheckPermissions };
